$(document).on("media-library:ready", () => {
  $(document).trigger("isofilter-model:ready");
  $(document).trigger("image-preloader:ready");

  // aianta.IsoFilter requires that each image with dynamic size in #iso-container is loaded
  const renderIsofilter = () => {
    const filterOptions = {
      itemClass: ".card-item",
      usaMap: "none",
    };
    const isofilter = new aianta.IsoFilter($("#iso-container"), filterOptions);
    $.each($(".filterbox-links"), function () {
      $(this).click(function (e) {
        e.preventDefault();
        const link = $(this);
        const linkActive = link.attr("data-activelink");
        const categoryFilter = link.data("filter");
        if (linkActive === "true") {
          link.removeClass("active");
          link.attr("data-activelink", "false");
          isofilter.removeCategoryFilter(categoryFilter);
        } else {
          link.addClass("active");
          link.attr("data-activelink", "true");
          isofilter.addCategoryFilter(categoryFilter);
          isofilter.addLinkWatcher(link);
        }
        isofilter.setFilters();
      });
    });
  };
  const bodyImagePreloader = new aianta.ImagePreloader($("body"));

  const imagesSrc = $("#iso-container img").map(function () {
    return $(this).attr("src");
  });
  bodyImagePreloader.process(imagesSrc, renderIsofilter);
});
